export default "__VITE_ASSET__Dv7fHLRD__"